import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	holidays: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holidays',
		defaultMessage: 'Holidays',
		description: 'header for holidays section',
	},
	addSomeHolidays: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.add-some-holidays',
		defaultMessage: 'Add some holidays!',
		description: 'label displayed when no holidays present on the screen',
	},
	holidaysDescription: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.holidays-description',
		defaultMessage: 'Add holiday dates to pause your SLAs. ',
		description: 'description for holidays section under the header',
	},
	importHolidaysDescription: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.import-holidays-description',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'Import holidays from an ICS file or add them manually.',
		description: 'description for holidays section under the header for importing ics files',
	},
	name: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.name',
		defaultMessage: 'Name',
		description: 'description for holidays table name header',
	},
	date: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.date',
		defaultMessage: 'Date',
		description: 'description for holidays table date header',
	},
	frequency: {
		id: 'servicedesk-sla-settings.calendars.editable.fields.holidays.frequency',
		defaultMessage: 'Frequency',
		description: 'description for holidays table frequency header',
	},
});
